export const CORES_TIPO = {
  PROCEDIMENTO: {
    backgroundColor: "#e7efff",
    color: "#0e3dcf",
  },
  MEDICAMENTO: {
    backgroundColor: "#f1e8ff",
    color: "#6f2dff",
  },
  DESLOCAMENTO: {
    backgroundColor: "#fff4d9",
    color: "#ff9f00",
  },
  ADICIONAL: {
    backgroundColor: "#e7ffe9",
    color: "#0e9f2e",
  },
};

export const SIGLAS_TIPO = {
  PROCEDIMENTO: "PRO",
  MEDICAMENTO: "MED",
  ADICIONAL: "ADI",
  DESLOCAMENTO: "DES",
};

export function getEstiloTipo(tipo) {
  return CORES_TIPO[tipo] || CORES_TIPO.PROCEDIMENTO;
}

export function getSiglaTipo(tipo) {
  return SIGLAS_TIPO[tipo] || tipo?.slice(0, 3)?.toUpperCase() || "—";
}
